// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z6oQ","name":"styles_name__2SuQN","phone":"styles_phone__y_qaW"};